import { render, staticRenderFns } from "./pivotalInput.vue?vue&type=template&id=010286cd&scoped=true&"
import script from "./pivotalInput.vue?vue&type=script&lang=ts&"
export * from "./pivotalInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010286cd",
  null
  
)

export default component.exports